import { styled } from '@mui/system';
import DialogTitle from '@mui/material/DialogTitle';

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main
}));
